<div data-testid="onscreen-info"
     class="onscreen-info flex flex-row justify-content-between align-items-start">

  <div>
    <h3>{{'APP_INFO.APP_INFO_AREAS.' + translateKey + '.TITLE' | translate}}</h3>
    <p [innerHTML]="'APP_INFO.APP_INFO_AREAS.' + translateKey + '.CONTENT_P1' | translate"></p>
    <p [innerHTML]="'APP_INFO.APP_INFO_AREAS.' + translateKey + '.CONTENT_P2' | translate"></p>
    <p [innerHTML]="'APP_INFO.APP_INFO_AREAS.' + translateKey + '.CONTENT_P3' | translate"></p>
    <p [innerHTML]="'APP_INFO.APP_INFO_AREAS.' + translateKey + '.CONTENT_P4' | translate"></p>
    <p [innerHTML]="'APP_INFO.APP_INFO_AREAS.' + translateKey + '.CONTENT_P5' | translate"></p>
    <p [innerHTML]="'APP_INFO.APP_INFO_AREAS.' + translateKey + '.CONTENT_P6' | translate"></p>
  </div>

  <div>
    <button type="button" pButton iconOnly
      (click)="closeOnScreenInfo()"
      [attr.aria-label]="'APP_INFO.BUTTONS.CLOSE_ON_SCREEN_INFO.ARIA_LABEL' | translate"
      class="p-button-rounded p-button-text p-button-secondary">
      <i class="pi pi-times"></i>
    </button>
  </div>

</div>
